import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";

import { Div } from "components/Base";

import {
  getApplications,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize
} from "Portal/NewPortal/PortalHome/selectors";

import Application from "./Application";
import { actions } from "Portal/NewPortal/PortalHome/model";

const decorate = R.compose(
  connect(
    state => ({
      applications: getApplications(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state)
    }),
    {
      onClickPanelHeader: actions.setSelectedCategory
    }
  )
);

const Applications = ({ applications = [] }) => {
  if (R.isEmpty(applications)) {
    return null;
  }

  return (
    <Panel
      title="Applications"
      length={applications.length}
      panelContainerStyle={{
        maxHeight: "400px",
        height: "auto",
        overflow: "auto"
      }}
      icon="assignment"
      onClickHeader={undefined}
    >
      <Div display="column.flex-start.flex-end" style={{ gap: "12px" }}>
        {R.map(application => {
          return <Application key={application.id} {...application} />;
        }, applications)}
      </Div>
    </Panel>
  );
};

export default decorate(Applications);
